import { EmailSuggestion } from '@/components/EmailSuggestion';
import type { EmailGuard } from '@/lib/useEmailCheck';

export interface GuardSuggestionProps {
  guard: EmailGuard;
  /** DOM id prefix: the block is `{idPrefix}.suggestion`. */
  idPrefix: string;
  /** Called with the address the user picked (Use or Keep): set the field and resubmit with it. */
  onAnswer: (address: string) => void;
  disabled?: boolean;
}

/** The "Did you mean" prompt of one `useEmailGuard`, rendered under its field. */
export function GuardSuggestion({
  guard,
  idPrefix,
  onAnswer,
  disabled,
}: GuardSuggestionProps) {
  const { prompt } = guard;
  if (!prompt) return null;
  const answer = (kind: 'use' | 'keep') => {
    const address = guard.answer(kind);
    if (address) onAnswer(address);
  };
  return (
    <EmailSuggestion
      idPrefix={idPrefix}
      suggestion={prompt.suggestion}
      typed={prompt.typed}
      disabled={disabled}
      onUse={() => answer('use')}
      onKeep={prompt.refused ? undefined : () => answer('keep')}
    />
  );
}
